<template>
  <coming-soon />
</template>

<script>
import ComingSoon from "@/views/components/coming-soon/ComingSoon.vue";
export default {
  components: {
    ComingSoon,
  },
};
</script>

<style></style>